import styled from 'styled-components';

export const Button = styled.div<{ active?: boolean }>`
  min-width: 111px;
  height: 35px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.active ? 'var(--ant-primary-color)' : '#fafafa')};
  color: ${(props) => (props.active ? '#fff' : '#999')};
  font-size: 16px;
  margin-right: 22px;
  margin-bottom: 25px;
  cursor: pointer;
`;
